import { render, staticRenderFns } from "./mySample.vue?vue&type=template&id=d71b8f3c&scoped=true&"
import script from "./mySample.vue?vue&type=script&lang=js&"
export * from "./mySample.vue?vue&type=script&lang=js&"
import style0 from "./mySample.vue?vue&type=style&index=0&id=d71b8f3c&lang=scss&scoped=true&"
import style1 from "./mySample.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71b8f3c",
  null
  
)

export default component.exports